module.exports = __webpack_public_path__ + "static/media/WBNB2B_Industrial_manufacturers_global_exporters_B2B_1_California.23f4f82c.png";